(function () {
  'use strict';

  function initHeroGalleryArrows() {
    document.querySelectorAll('.pd.pd--gallery-thumbs-bottom').forEach(function (section) {
      var desktop = section.querySelector('[data-pd-gallery-desktop]');
      if (!desktop) return;
      var prevBtn = desktop.querySelector('.pd__gallery-arrow--hero.pd__gallery-arrow--prev');
      var nextBtn = desktop.querySelector('.pd__gallery-arrow--hero.pd__gallery-arrow--next');
      if (!prevBtn || !nextBtn) return;
      if (prevBtn.__pdHeroBound) return;
      prevBtn.__pdHeroBound = true;

      function getCurrentIndex() {
        var active = desktop.querySelector('[data-pd-gallery-main] .pd__gallery-slide.is-active');
        if (!active) return 0;
        return parseInt(active.getAttribute('data-pd-slide'), 10) || 0;
      }

      function getTotalSlides() {
        return desktop.querySelectorAll('[data-pd-gallery-main] .pd__gallery-slide').length;
      }

      function navigateTo(idx) {
        var total = getTotalSlides();
        if (!total) return;
        idx = ((idx % total) + total) % total;
        var thumb = desktop.querySelector('[data-pd-slide-to="' + idx + '"]');
        if (thumb) thumb.click();
      }

      prevBtn.addEventListener('click', function () {
        navigateTo(getCurrentIndex() - 1);
      });

      nextBtn.addEventListener('click', function () {
        navigateTo(getCurrentIndex() + 1);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroGalleryArrows);
  } else {
    initHeroGalleryArrows();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      setTimeout(initHeroGalleryArrows, 0);
    }
  });
})();
